{
  "common": {
    "accountName": "公司账户名",
    "admin": "管理员",
    "callsign": "编号",
    "cancel": "取消",
    "confirm": "确认",
    "confirmPassword": "确认密码",
    "createAccount": "创建账户",
    "delete": "删除",
    "deleted": "已删除",
    "developing": "开发中",
    "devDebug": "开发调试",
    "documentation": "开发文档",
    "download": "下载",
    "edit": "修改",
    "email": "邮箱",
    "emailErrorRequiredLabel": "请输入邮箱。",
    "emailErrorEmailFormatLabel": "请输入正确的邮箱地址。",
    "experimental": "实验功能",
    "failed": "出错",
    "firstName": "名字",
    "functions": "函数命令",
    "invite": "邀请",
    "invitation": "{{common.invite}}",
    "invitations": "{{common.invite}}",
    "invitationCode": "邀请码",
    "highlight": "高亮",
    "lastName": "姓氏",
    "mapEditor": "地图编辑器",
    "modified": "编辑",
    "more": "更多",
    "name": "名称",
    "newProject": "新{{common.project}}",
    "operations": "运营",
    "open": "打开",
    "organizationName": "组织（公司）名称",
    "password": "密码",
    "pleaseEnter": "请输入{{field}}。",
    "project": "项目",
    "projects": "{{common.project}}",
    "publish": "发布",
    "reportABug": "错误提交",
    "requiredLabel": "必填项",
    "resetPassword": "重置密码",
    "robot": "机器人",
    "robotCallsign": "{{common.robot}}{{common.callsign}}",
    "robotDefinitions": "机器人模板",
    "robots": "机器人",
    "save": "保存",
    "sendEmail": "发送邮件",
    "signIn": "登录",
    "signOut": "退出登陆",
    "signUp": "注册",
    "size": "大小",
    "settings": "设置",
    "storageExplorer": "数据浏览器",
    "storageQuery": "数据挖掘",
    "storageStreams": "数据集成管理",
    "exportButton": "导出",
    "automate": "自动化任务"
  },
  "core": {
    "comfirmDialog": {
      "doYouWantToContinue": "你是否还想继续?"
    },
    "projectCard": {
      "deleteProject": "{{common.delete}}{{common.project}}",
      "deleteWarning": "警告! 您将要执行的操作无法撤消。确认执行后将永久删除此项目，包括其所有相关资源和储存的数据。",
      "deleteConfirm": "请输入项目名称进行确认",
      "invitePeople": "发送{{common.invite}}",
      "inviteSent": "{{common.invite}}已发送",
      "projectUpdated": "{{common.project}}已更新"
    },
    "login": {
      "forgotPasswordButtonLabel": "忘记密码？",
      "passwordErrorRequiredLabel": "请输入密码。"
    },
    "navBar": {
      "adminOnlyHide": "{{common.admin}}可见 (隐藏)",
      "adminOnlyShow": "{{common.admin}}可见 (显示)",
      "developingHide": "{{common.developing}} (隐藏)",
      "developingShow": "{{common.developing}} (显示)",
      "experimentalHide": "{{common.experimental}} (隐藏)",
      "experimentalShow": "{{common.experimental}} (显示)",
      "highlightEnable": "{{common.highlight}} (启用)",
      "highlightDisable": "{{common.highlight}} (禁用)"
    },
    "resetPassword": {
      "description": "请输入您的电子邮箱地址，我们将会发送邮件协助您重置密码。"
    },
    "signUp": {
      "accountNameLabel": "公司账户名 （不用于登陆）",
      "ackownledgementMessage": "注册此平台即表示您同意ROCOS的<a href=\"https://www.dronedeploy.com/legal/master-services-agreement/\">使用条款</a>和<a href=\"https://content.rocos.io/privacy.html\">隐私政策</a>。",
      "confirmYourPassword": "请确认您的密码。",
      "emailHasBeenTakenErrorLabel": "此邮箱已被注册。请使用其他邮箱注册。",
      "nameIncorrectErrorLabel": "您确认输入了正确的名称吗？",
      "passwordRequiredErrorLabel": "请输入密码",
      "passwordStrengthErrorLabel": "请选择一个高强度密码。 8个以上字符，必需含有大写字母、小写字母、数字及特殊字符。如果无法使用特殊字符，请包含12个以上字符。",
      "passwordStrengthHintLabel": "使用8个字符以上包含大写字母，小写字母，数字和特殊字符的密码。如果无法使用特殊字符，请包含12个以上字符。",
      "signInInsteadButtonLabel": "返回登录"
    }
  },
  "mapEditor": {
    "eraser": "橡皮擦",
    "exportPGM": "导出PGM",
    "exportPGMTooltip": "导出PGM文件",
    "exportYaml": "导出YAML",
    "exportYamlTooltip": "导出YAML文件",
    "importPGM": "导入PGM",
    "importPGMTooltip": "上传PGM文件",
    "importYaml": "导入YAML",
    "importYamlTooltip": "上传YAML文件",
    "openPGMFromRobot": "远程打开地图文件",
    "openPGMFromRobotDialogTitle": "{{mapEditor.openPGMFromRobot}}",
    "openPGMFromRobotTooltip": "远程打开地图文件",
    "savePGMToRobot": "保存PGM到{{common.robot}}",
    "savePGMToRobotDialogTitle": "{{mapEditor.savePGMToRobot}}",
    "savePGMToRobotTooltip": "保存PGM到{{common.robot}}",
    "openYamlFromRobot": "远程打开YAML文件",
    "openYamlFromRobotDialogTitle": "{{mapEditor.openYamlFromRobot}}",
    "openYamlFromRobotTooltip": "远程打开YAML文件",
    "saveYamlToRobot": "保存YAML到{{common.robot}}",
    "saveYamlToRobotDialogTitle": "{{mapEditor.saveYamlToRobot}}",
    "saveYamlToRobotTooltip": "保存YAML到{{common.robot}}",
    "pencil": "画笔",
    "straightLine": "直线"
  },
  "fileExplorer": {
    "emptyFolderMessage": "空文件夹。",
    "fileName": "文件名",
    "pluginNotAvailbaleMessage": "文件传送插件尚未启用。请通过客户端设置页面启用。",
    "newFolder": "新建文件夹",
    "uploadFile": "上传文件"
  }
}
